import { createContext } from 'react';

const NavigationContext = /*#__PURE__*/createContext({
  location: ''
});

export { NavigationContext };
